import React, { Component } from "react";
import GridSystem from "./GridSystem";
import Headings from "./Headings";
import Alignment from "./Alignment";
import Color from "./Color";
import FontFamily from "./FontFamily";
import FontWeight from "./FontWeight";
import FontSize from "./FontSize";
import FontStyle from "./FontStyle";
import Padding from "./Padding";
import Dimension from "./Dimension";
import Upload from "./Upload";
import Link from "./Link";
import Divider from './Divider';
import BackgroundColor from "./BackgroundColor";
import Paper from "./Paper";
import ScmName from "./ScmName";
import ScmCondtion from "./ScmCondtion";
import InputText from './InputText';
// import Text from "./TextElement";

class SwitchElementsProperties extends Component {
  constructor(props) {
    super(props);
  }
  // componentDidUpdate = (prevProps) =>{
  // }
  render() {
    const {type} = this.props;
    const paramState = {
      ...this.props
    }
    // console.log('typetype',type);
    switch (type) {
      case "GridSystem":
        return <GridSystem  {...paramState} />;
      case "Headings":
        return <Headings  {...paramState} />;
      case "Alignment":
        return <Alignment {...paramState}/>;  
      case "Color":
        return <Color {...paramState}/>;
      case "FontFamily":
        return <FontFamily {...paramState}/>;
      case "FontWeight":
        return <FontWeight {...paramState}/>;
      case "FontSize":
        return <FontSize {...paramState}/>;
      case "FontStyle":
        return <FontStyle {...paramState}/>;
      case "Padding":
        return <Padding {...paramState}/>;
      case "BackgroundColor":
        return <BackgroundColor {...paramState}/>;  
      case "Dimension":
        return <Dimension {...paramState}/>;
      case "Upload":
        return <Upload {...paramState}/>;
      case "Link":
        return <Link {...paramState}/>;
      case "Divider":
        return <Divider {...paramState}/>; 
      case "Paper":
        return <Paper {...paramState}/>; 
      case "SCM:NAME":
        return <ScmName {...paramState}/>;
      case "SCM:CONDITION":
        return <ScmCondtion {...paramState}/>;
      case "Text":
        return <InputText {...paramState}/>;                    
      default:
        return false;
        
    }
  }
}

SwitchElementsProperties.defaultProps = {
  screen: "Layout",
}

export default SwitchElementsProperties;

 
